"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpsertAccountZuoraPayloadSchema = void 0;
exports.UpsertAccountZuoraPayloadSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
        },
        paymentGateway: {
            type: 'string',
            minLength: 1,
        },
        communicationProfileId: {
            type: 'string',
            minLength: 1,
        },
        currency: {
            type: 'string',
            minLength: 1,
        },
        sequenceSetId: {
            type: 'string',
            minLength: 1,
        },
        salesforceAccountId: {
            type: 'string',
            minLength: 1,
        },
        invoiceTemplateId: {
            type: 'string',
            minLength: 1,
        },
        billToContact: {
            properties: {
                address1: {
                    type: 'string',
                    minLength: 1,
                },
                address2: {
                    type: 'string',
                },
                city: {
                    type: 'string',
                    minLength: 1,
                },
                country: {
                    type: 'string',
                    minLength: 1,
                },
                firstName: {
                    type: 'string',
                    minLength: 1,
                },
                lastName: {
                    type: 'string',
                    minLength: 1,
                },
                zipCode: {
                    type: 'string',
                    minLength: 1,
                },
                state: {
                    type: 'string',
                },
                workEmail: {
                    type: 'string',
                    minLength: 1,
                },
            },
            required: [
                'address1',
                'address2',
                'city',
                'country',
                'firstName',
                'lastName',
                'zipCode',
                'workEmail',
            ],
            type: 'object',
        },
        paymentMethodId: {
            type: 'string',
            minLength: 1,
        },
        legalEntity: {
            type: 'string',
            minLength: 1,
        },
        sonosId: {
            type: 'string',
            minLength: 1,
        },
        messageId: {
            type: 'string',
            minLength: 1,
        }
    },
    required: [
        'name',
        'paymentGateway',
        'communicationProfileId',
        'currency',
        'sequenceSetId',
        'salesforceAccountId',
        'invoiceTemplateId',
        'billToContact',
        'paymentMethodId',
        'legalEntity',
        'sonosId',
        'messageId'
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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